// The AI chat's "Add reference → Deskey Hub" tab: the school's published
// Hub documents (GET /api/hub/teacher/docs/search). Picking one sends a
// `hub_doc` chip; the backend (chat_references.py) gives the AI its text.

export const HUB_TAB_LABEL = 'Deskey Hub';
export const HUB_DOCS_LIMIT = 60;

const MIME_LABELS = {
  'application/pdf': 'PDF',
  'application/msword': 'Word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
  'application/vnd.ms-powerpoint': 'PowerPoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PowerPoint',
  'text/plain': 'Text',
};

export function fileTypeLabel(doc) {
  const mime = (doc?.mime_type || '').toLowerCase();
  if (MIME_LABELS[mime]) return MIME_LABELS[mime];
  if (mime.startsWith('image/')) return 'Image';
  const ext = (doc?.file_ext || '').replace(/^\./, '');
  return ext ? ext.toUpperCase() : '';
}

/** A Hub search result → the popover's library row ({ id, title, subject }). */
export function toHubLibraryItem(doc) {
  return {
    id: doc.id,
    title: doc.title || 'Untitled document',
    subject: [doc.subject_name, doc.department_name, fileTypeLabel(doc)].filter(Boolean).join(' · '),
  };
}
